import React from 'react'
import { Check, Info } from 'lucide-react'
import type { Status } from './CardRequireDocuments'


type Props = {
  status: Status
  label?: string
}

export const StatusBadge: React.FC<Props> = ({ status, label }) => {
  const isSuccess = status === true

  return (
    <div
      className={`inline-flex items-center gap-2 p-1
        ${
          isSuccess
            ? 'bg-(--crayon-green)'
            : 'bg-(--strokes-orange)'
        }
      `}
    >
      <div
        className={`w-4 h-4 flex items-center justify-center rounded-full border border-(--gray)`}
      >
        {isSuccess ? (
          <Check className="w-2.5 h-2.5" />
        ) : (
          <span className="text-xs font-bold leading-none">!</span>
        )}
      </div>

      <span>{label ?? (isSuccess ? 'Caricato' : 'Da caricare')}</span>
    </div>
  )
}